import { render, staticRenderFns } from "./fileOperate.vue?vue&type=template&id=8805659c&scoped=true&"
import script from "./fileOperate.vue?vue&type=script&lang=js&"
export * from "./fileOperate.vue?vue&type=script&lang=js&"
import style0 from "./fileOperate.vue?vue&type=style&index=0&id=8805659c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8805659c",
  null
  
)

export default component.exports